import * as React from 'react';
import { STATE } from 'app/constants';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';
import { ListWrapper } from './components/list-wrapper';
import { ListRenderer } from './components/list-renderer';
import { actionCreators } from './actions';
import { externalUrlGroupsTranslation } from '../constants';
import { ExternalUrlGroupsState } from '../types-store';
import { scrollToTop } from 'app/infrastructure/platform/routing';

export type ExternalUrlGroupsListProps = DefaultContainerProps
  & ExternalUrlGroupsState
  & typeof actionCreators;

class ExternalUrlGroupsListComponent extends React.PureComponent<ExternalUrlGroupsListProps> {
  public static statePath: string = STATE.externalUrlGroups;

  public componentWillUnmount() {
    this.props.clearList();
  }

  public componentDidMount() {
    scrollToTop();
  }

  public render() {

    const { list, sharedState, translation,
      loadExternalUrlList, deleteExternalUrlGroup: deleteExternalUrl, displayError } = this.props;

    return <ListWrapper
      displayError={displayError}
      sharedState={sharedState}
      translation={translation}>
      <ListRenderer
        listState={list}
        loadList={loadExternalUrlList}
        deleteExternalUrl={deleteExternalUrl}
        translation={translation}
      />
    </ListWrapper>;
  }
}

const container = containerFactory(ExternalUrlGroupsListComponent, actionCreators, undefined, externalUrlGroupsTranslation);

export { container as ExternalUrlGroupsList };
